import { render } from "./PendingReturnHelpDialog.vue?vue&type=template&id=55d8a3c5&scoped=true"
import script from "./PendingReturnHelpDialog.vue?vue&type=script&lang=js"
export * from "./PendingReturnHelpDialog.vue?vue&type=script&lang=js"

import "./PendingReturnHelpDialog.vue?vue&type=style&index=0&id=55d8a3c5&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d8a3c5"]])

export default __exports__